module.exports = __webpack_public_path__ + "img/payment-options-1.b605a073.svg";